exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul li[data-v-457e12f9] {\n  list-style: none;\n}\nspan.status[data-v-457e12f9] {\n  position: relative;\n  padding-left: 12px;\n}\nspan.status[data-v-457e12f9]::after {\n  content: \"\";\n  position: absolute;\n  top: 4px;\n  left: -2px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n}\nspan.online[data-v-457e12f9]::after {\n  background: green;\n}\nspan.offline[data-v-457e12f9]::after {\n  background: red;\n}\n", ""]);

// exports
